import { useToastStore } from '@/stores/toast';
import { Icon } from '@/design-system/icons/Icon';

export const Toaster = () => {
  const toasts = useToastStore((s) => s.toasts);
  return (
    <div className="toast-wrap" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className="toast" role="status">
          <Icon name={t.icon} size={16} className="ic" />
          <span>{t.message}</span>
        </div>
      ))}
    </div>
  );
};
